var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "panel panel-default" }, [
      _c("div", { staticClass: "panel-heading" }, [
        _c("h3", { staticClass: "panel-title" }, [
          _vm._v("3. Create Your Post"),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "panel-body" }, [
        _c("ol", [
          _c("li", [_vm._v("Switch to Instagram")]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Use the newly added media from your device's library for the post content"
            ),
          ]),
          _vm._v(" "),
          _c("li", [_vm._v("Paste your caption")]),
          _vm._v(" "),
          _c("li", [_vm._v('Click "Share" and that\'s it!')]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }